import Carousel from "react-bootstrap/Carousel";
import { useState } from "react";
import "./CustomCurousel.scss";
import { AllImages } from "../../Assets/Images/AllImages";
import Button from "../Button/Button";
import user from "../JsonFiles/simran.json";

const CustomCurousel = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };
  const openProject = (item) => {
    window.open(item?.url);
  };

  return (
    <Carousel
      fade={false}
      className="carousel-main-container"
      activeIndex={index}
      slide={false}
      interval={null}
      onSelect={handleSelect}
    >
      {user?.projects?.map((item,id) => (
        <Carousel.Item key={id.toString()}>
          <div className="carausel-img-head-sub-head">
            {/* <iframe className="carausel-img" src={item?.url} ></iframe> */}
            <img className="carausel-img" src={AllImages[item?.img]} alt="" />
            <div className="carausel-head-sub-head">
              <div className="carausel-head">{item?.name}</div>
              <div className="carausel-sub-head">{item?.description}</div>
              {item?.url !== null && (
                <div
                  className="carausel-demo-btn"
                  onClick={() => openProject(item)}
                >
                  <Button name="Demo" />
                </div>
              )}
            </div>
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};
export default CustomCurousel;
